function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "add-document");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "add-document",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M528,596.384615 L528,641.615385 C528,652.276923 519.225,661 508.5,661 L235.5,661 C224.775,661 216,652.276923 216,641.615385 L216,596.384615 C216,585.723077 224.775,577 235.5,577 L508.5,577 C519.225,577 528,585.723077 528,596.384615 Z M508.5,713 L235.5,713 C224.775,713 216,721.723077 216,732.384615 L216,777.615385 C216,788.276923 224.775,797 235.5,797 L508.5,797 C519.225,797 528,788.276923 528,777.615385 L528,732.384615 C528,721.723077 519.225,713 508.5,713 Z M683,407.822266 L683,946.1875 C683,989.146484 648.11849,1024 605.125,1024 L137.875,1024 C94.8815104,1024 60,989.146484 60,946.1875 L60,271.8125 C60,228.853516 94.8815104,194 137.875,194 L469.00599,194 C489.610417,194 509.403646,202.267578 524.005208,216.857422 L660.124219,352.867188 C674.725781,367.294922 683,387.234375 683,407.822266 Z M476,278 L476,401 L599,401 L476,278 Z M606,947 L606,479.692308 L437,479.692308 C415.3875,479.692308 398,462.330529 398,440.75 L398,272 L138,272 L138,947 L606,947 Z",
  id: "Shape",
  fill: "#05CDB3",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M998.428571,140.642857 L883.357143,140.642857 L883.357143,25.5714286 C883.357143,11.4512054 871.905938,0 857.785714,0 L832.214286,0 C818.094062,0 806.642857,11.4512054 806.642857,25.5714286 L806.642857,140.642857 L691.571429,140.642857 C677.451205,140.642857 666,152.094063 666,166.214286 L666,191.785714 C666,205.905938 677.451205,217.357143 691.571429,217.357143 L806.642857,217.357143 L806.642857,332.428571 C806.642857,346.548795 818.094063,358 832.214286,358 L857.785714,358 C871.905938,358 883.357143,346.548795 883.357143,332.428571 L883.357143,217.357143 L998.428571,217.357143 C1012.54879,217.357143 1024,205.905938 1024,191.785714 L1024,166.214286 C1024,152.094062 1012.54879,140.642857 998.428571,140.642857 Z",
  id: "Path",
  fill: "#05CDB3",
  fillRule: "nonzero"
}));

var SvgAddDocument = function SvgAddDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-document.21442d84.svg";
export { ForwardRef as ReactComponent };